import { create } from "zustand"

interface ComposerState {
  /** Text to seed the chat composer with (e.g. a "send back" revision request). */
  prefill: string
  prefillNonce: number
  setPrefill: (text: string) => void
  clearPrefill: () => void
}

export const useComposerStore = create<ComposerState>((set) => ({
  prefill: "",
  prefillNonce: 0,
  setPrefill: (text) => set((s) => ({ prefill: text, prefillNonce: s.prefillNonce + 1 })),
  clearPrefill: () => set({ prefill: "" }),
}))
